import React, { FunctionComponent } from "react"
import EALAService from "../../Utils/EALAService"
import "./AddEALASuggestPromotion.css"

interface Props {
    AccessLevelID: number
}

const AddEALASuggestPromotion: FunctionComponent<Props> = (props) => {

    const { AccessLevelID } = props
    const { getPromotionSuggestion } = EALAService

    return (
        <div className="AddEALASuggestPromotion">
            <div className="AddEALASuggestPromotionHeader">
                <div className="AddEALASuggestPromotionHeaderTop">
                    <p>The employee cannot be assigned to any other areas; consider promoting them to:</p>
                </div>
                <div className="AddEALASuggestPromotionHeaderBottom">
                    <p>{getPromotionSuggestion(AccessLevelID)}</p>
                </div>
            </div>
        </div>
    )
}

export default AddEALASuggestPromotion